import { supabase } from './client';

export async function isUpdateCardHidden(userId: string): Promise<boolean> {
  try {
    const { data, error } = await supabase
      .from('user_ui_preferences')
      .select('hide_update_card')
      .eq('user_id', userId)
      .maybeSingle();

    if (error) {
      console.error('Erro ao buscar preferência:', error);
      return false;
    }

    return data?.hide_update_card ?? false;
  } catch (error) {
    console.error('Erro ao verificar se card está oculto:', error);
    return false;
  }
}

export async function hideUpdateCard(userId: string): Promise<boolean> {
  try {
    const { error } = await supabase
      .from('user_ui_preferences')
      .upsert(
        {
          user_id: userId,
          hide_update_card: true,
          updated_at: new Date().toISOString(),
        },
        { onConflict: 'user_id' }
      );

    if (error) {
      console.error('Erro ao ocultar card:', error);
      return false;
    }

    return true;
  } catch (error) {
    console.error('Erro ao salvar preferência:', error);
    return false;
  }
}

export async function showUpdateCard(userId: string): Promise<boolean> {
  try {
    const { error } = await supabase
      .from('user_ui_preferences')
      .upsert(
        {
          user_id: userId,
          hide_update_card: false,
          updated_at: new Date().toISOString(),
        },
        { onConflict: 'user_id' }
      );

    if (error) {
      console.error('Erro ao mostrar card:', error);
      return false;
    }

    return true;
  } catch (error) {
    console.error('Erro ao salvar preferência:', error);
    return false;
  }
}
